import { useQuery } from "@tanstack/react-query";

import { getOverview } from "../services/overview";

export function useOverview(options = {}) {

    const outletUid = localStorage.getItem(

        "selectedOutletUid"

    );

    return useQuery({

        queryKey: [

            "overview",

            outletUid,

        ],

        queryFn: () =>

            getOverview(

                outletUid

            ),

        enabled: !!outletUid,

        staleTime: 1000 * 60 * 5,

        ...options,

    });

}